import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import FormDisplay from "./FormDisplay";
import { useAxios, useAlert } from "../../../hooks";
import { signInMember } from "../../../redux/slices/memberSlice";
import { signInDetailsObject, validationSchema } from "./signInDetailsObject";
import pages from "../../../constants/pages";

export default function Form() {
  const axios = useAxios({ disableAuthToken: true });

  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Formik
      enableReinitialize
      initialValues={signInDetailsObject}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(formData, { setSubmitting }) => {
        axios({
          url: "/vahan-login",
          method: "POST",
          data: {
            email: formData.email,
            password: formData.password,
          },
          disableRedirect: true,
        })
          .then((res) => {
            if (res.status) {
              dispatch(
                signInMember({
                  authToken: res.data.auth_token,
                })
              );

              dispatch(alert({ message: "Welcome!", type: "success" }));

              navigate(pages.rcDetails.route);
            }
            setSubmitting(false);
          })
          .catch((err) => {
            console.error(err);
          });
      }}
    >
      {(formikProps) => (
        <form onSubmit={formikProps.handleSubmit}>
          <FormDisplay formikProps={formikProps} />
        </form>
      )}
    </Formik>
  );
}
